import { TkCargoUrls } from "../Constants/urlConstants";

// Splits an AWB (Air Waybill) number into its prefix and document number components.
export const splitAwb = (awb: string) => {
  if (!awb) return {};

  const cleaned = awb.replace(/-/g, "").replace(/\s/g, "");
  if (cleaned.length < 4) return {};

  const prefix = cleaned.substring(0, 3);
  const docNumber = cleaned.substring(3);

  return {
    prefix,
    docNumber,
  };
};

// Generates a tracking URL for Turkish Cargo based on the provided AWB number.
export const getTkCargoTrackingUrl = (awb: string) => {
  if (!awb) return "";

  const { prefix, docNumber } = splitAwb(awb);
  if (!prefix || !docNumber) return "";

  return `${TkCargoUrls.BASE}${TkCargoUrls.TRACKING}?awbPrefix=${prefix}&awbNumber=${docNumber}`;
};
